<template>
        <form
            @submit.prevent="update"
            :action="url"
            method="post"
            class="p-4 border-2 border-sky-500 rounded bg-white flex flex-col gap-4"
        >
        <h1 class="text-2xl text-gray-800 font-bold text-center">
            Update Subscriber
        </h1>

        <text-input
            label="Email"
            placeholder="taylor@yourcompany.com"
            v-model="form.email"
            :error="form.errors.email"
        />

        <div class="flex items-center gap-4">
            <label for="subscribed" class="form-label">
                Subscribed:
            </label>

            <input
                v-model="form.subscribed"
                type="checkbox"
                name="subscribed"
                id="subscribed"
                class="rounded p-2 focus:outline-none focus:ring-sky-500 focus:ring-2 focus:ring-opacity-50 focus:ring-offset-0 text-sky-500"
            />
        </div>

        <loading-button
            :loading="form.processing"
            class="btn btn-green"
            type="submit"
        >
            Update
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { useNotificationStore } from '@/stores/notification'

const notification = useNotificationStore()

const props = defineProps({
    subscriber: {
        type: Object,
        required: true,
    },
    url: {
        type: String,
        required: true
    }
})

const form = useForm({
    email: props.subscriber.email,
    subscribed: props.subscriber.subscribed
})

const update = () => {
    notification.clear()
    form.put(props.url, {
        onSuccess: () => {
            notification.set({
                type: 'alert',
                body: 'Your information was successfully updated.',
                level: 'success',
            })
        }
    })
}
</script>
